import {
  VStack,
  HStack,
  Text,
  Avatar,
  AvatarFallbackText,
  View
} from "@gluestack-ui/themed";
import { SideMenuProps } from "./types";
import { MenuItem } from "./components/MenuItem";
import { CanView } from "@repo/core/components/core/CanView";
import { useAppVersion } from "@repo/core/hooks/useAppVersion";
export const SideMenu = ({
  items,
  showHeader = true,
  headerTitle = "",
  headerSubtitle = "",
  onItemPress
}: SideMenuProps) => {
  const appVersion = useAppVersion();

  return (
    <View flex={1} gap="$1" width={"$full"} backgroundColor="$backgroundLight0">
      {/* HEADER */}
      {showHeader && (
        <VStack borderBottomWidth={1} borderColor="$borderLight200" px={"$4"}>
          <HStack
            alignItems="center"
            justifyContent="flex-start"
            px={"$2"}
            py={"$4"}
            gap="$2"
          >
            <Avatar
              bgColor="$amber600"
              w={"$12"}
              h={"$12"}
              rounded="$full"
              borderWidth={1}
              borderColor="$borderLight300"
            >
              <AvatarFallbackText color="white">
                {headerTitle}
              </AvatarFallbackText>
            </Avatar>

            <VStack flex={1} gap="$1">
              <Text
                color="$textDark800"
                fontSize={"$sm"}
                lineBreakMode="head"
                fontWeight={600}
                numberOfLines={1}
              >
                {headerTitle}
              </Text>

              <Text color="$textDark800" fontSize={"$xs"} fontWeight={400}>
                {headerSubtitle}
              </Text>
            </VStack>
          </HStack>
        </VStack>
      )}

      <VStack p={"$4"}>
        <VStack gap="$2">
          {items?.map((item) => (
            <CanView key={item.label} permissions={item.permissions}>
              <MenuItem
                icon={item.icon}
                label={item.label}
                fontColor={item.labelColor ?? "$secondary500"}
                iconColor={item.iconColor ?? "$secondary500"}
                onPress={() => onItemPress?.(item)}
              />
            </CanView>
          ))}
        </VStack>
      </VStack>
      <VStack pb="$4" flex={1} alignItems="center" justifyContent="flex-end">
        <Text fontSize="$sm" color="$secondary400">
          v{appVersion}
        </Text>
      </VStack>
    </View>
  );
};
